import { render, staticRenderFns } from "./HealthFloatBall.vue?vue&type=template&id=7dc31653&scoped=true&"
import script from "./HealthFloatBall.vue?vue&type=script&lang=js&"
export * from "./HealthFloatBall.vue?vue&type=script&lang=js&"
import style0 from "./HealthFloatBall.vue?vue&type=style&index=0&id=7dc31653&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc31653",
  null
  
)

export default component.exports